// extracted by mini-css-extract-plugin
module.exports = {"responsiveContainer":"wmTheme_mantine_responsiveContainer__Zcmfx"};